module.exports = __webpack_public_path__ + "img/Gallery_1_14.c54a927b.jpeg";